import { useEffect, useState } from "react"

const fq = {
  '游戏产品防沉迷': [
    [
      `游戏产品是否已经接入了防沉迷系统？`,
      `答：我司所有游戏产品都已合规接入了未成年人防沉迷系统。 <br />
      防沉迷新规: 未实名的玩家将不能登录游戏，未成年玩家登录游戏将会受到以下限制： <br />
      <br />
      一、时间限制 <br />
      未成年玩家可在周五、周六、周日和法定节假日每日晚20时至21时登录游戏，其他时间无法登录游戏。<br />
      <br />
      二、消费限制 <br />
      1. 8周岁以下(不含)无法进行充值。<br />
      2. 8周岁至16周岁(含8周岁，不含16周岁)充值单次不超过50元，每月累计不超过200元。<br />
      3. 16周岁至18周岁(含16周岁，不含18周岁)充值单次不超过100元，每月累计不超过400元。`
    ],
    [
      `为什么一定要实名认证？`,
      `答：根据2010年8月1日文化部推行的《网络游戏管理暂行办法》，网络游戏用户需使用本人有效身份证件进行实名注册。为享受健康游戏生活，请广大玩家尽快完成实名注册，以实现游戏的正常体验。`
    ],
    [
      `实名认证和防沉迷有什么区别？`,
      `答: 防沉迷系统以用户实名注册信息为判断依据 <br />
      1. 未经实名注册的用户，将无法进入游戏； <br />
      2. 已实名注册的用户，将根据年龄信息判断是否为未成年玩家(未满18周岁者)，如果是未成年玩家，将受到防沉迷系统的提示信息和游戏时长限制。`
    ]
  ],
  '未成年人消费': [
    [
      `我的孩子在游戏里充值了，能否申请退款？`,
      `答：如您的孩子未满18周岁，在游戏过程中产生了未经您同意的充值消费，您是可以通过联系游戏客服来申请退款的。请您点击下方“联系客服”进行申诉，我们会有专业的工作人员跟进您的问题。也请您尽快修改相关的安全支付信息，避免在申诉过程中再次发生消费。
      <br /> <br />
      （注：通过苹果账号进行的游戏内充值而产生未成年人退款申诉，需要您联系苹果客服进行退款申请。）`
    ],
    [
      `孩子在游戏里的消费明细如何查看？`,
      `答：打开未成年消费所使用的微信账号，点击右下角【我】-【服务】-【钱包】-【账单】- 此时您可以查看到该账号下所有的消费账单。请您将该笔或多笔的游戏充值账单详情，逐一截图保存，以便后续进行未成年人退款申诉使用。`
    ],
    [
      `为什么我的孩子是未成年，却能在游戏中产生大量消费？`,
      `答： <br />
      1. 对于微信小游戏产品，孩子可能是直接使用了您的移动设备，如手机，平板电脑等来进行游戏。也就是使用了您的微信账号及相关成年人实名认证信息来进行游戏行为；同时，孩子还需要知道您的支付密码。在此情况下，孩子有可能使用您的成年人身份，来完成一笔或多笔的充值行为。 <br />
      <br />
      2. 对于APP游戏产品，孩子可能在第一次进入游戏的时候输入了您的身份信息来完成实名认证操作，从而绕过防沉迷系统对未成年人的限制，出现孩子在游戏中充值的情况。 <br />
      <br />
      由于小朋友的消费意识不够成熟，如发生以上情况，首先希望您不要着急，更不要过分责备孩子。您可以通过“联系客服”找到我们，我们会有专业的工作人员来为您解决问题。
      `
    ],
    [
      `为什么我没有收到微信消费订单？`,
      `答：所有的消费订单都是有记录的，但微信中的消费账单是可以删除的。您可以通过以下方式进行找回： <br />
      <br />
      方法一：打开未成年消费所使用的微信账号 - 点击【我】-【服务】-【钱包】-【账单】-右上角【常见问题】-【下载账单】- 【用作证明材料】- 下载后查看消费记录 <br />
      <br />
      方法二：根据消费使用的银行卡，去相应的银行系统打印流水，查看消费记录。 <br />
      <br />
      如果您的孩子在我司游戏产品中进行了消费，您不确定累充金额具体是多少，欢迎您拨打我们的客服电话（400-6501866），我们会在关系证明材料审核通过后为您进行准确的累充金额查询。`
    ],
    [
      `孩子不知道支付密码的情况下能否完成充值？ `,
      `答：我司的全部游戏产品，在购买游戏内商品过程中，一定会要求用户输入正确的支付密码才可以购买成功。不会出现自动扣费或未使用密码的情况下支付成功。 <br />
      <br />
      注：如用户设定了指纹识别、面部识别等特殊支付方式，也需要在购买过程中，通过正确的支付验证信息来完成购买行为。`
    ]
  ],
  '未成年人退款申请': [
    [
      `如何联系客服申请退款？`,
      `答： <br />
      1. 我们为您提供专线电话，游戏内客服，公众号反馈三种方式方便您联系我们，具体联系方式请参见下方【联系客服】 <br />
      2. 请您确保提交正确的未成年人退款申请审核材料，以便我们尽快协助您解决问题。 <br />
      3. 如果我们审核您的情况属于真实未成年人游戏充值情况，我们将会为您进行退款操作。 <br />
      4. 通过【苹果账户】充值的用户，请您联系苹果公司进行未成年人审核及退款处理。`
    ],
    [
      `申请未成年人退款需要准备哪些材料？`,
      `答： <br />
      所需材料一： <br />
      1）如户口本中法定监护人页的户号和孩子页的户号相同，可提供监护人的户口页以及孩子的户口页，无需提供孩子出生证明。 <br />
      2)  法定监护人的身份证或户口本页，孩子的身份证或户口页，以及孩子的出生证明。 <br />
      以上两种证明方式二选一即可。 <br />
      <br />
      所需材料二： <br />
      3）至少一张游戏充值账单详情截图。`
    ],
    [
      `我提交的材料是否会被泄漏？`,
      `答：我司将会对监护人提交的身份材料信息进行严格保密。您所提供的所有身份信息资料仅用于申请未成年退款使用，不会作为其他任何商业用途。建议您在所提交的身份信息材料上增加标注【仅用于未成年人游戏退款使用】。`
    ],
    [
      `提交完材料后需要多久能收到退款？`,
      `答：退款申请审核通过后，将在1-5个工作日内为您操作退款。如无特殊情况，退还款项将会原路返回到您之前充值使用的账户中。`
    ],
    [
      `成功退款后，孩子是否还可以继续进行游戏？`,
      `答：当退款成功后，该游戏账号将永久封禁。`
    ]
  ],
  '未成年人苹果账号充值': [
    [
      `通过苹果账号充值的游戏，怎么申请未成年人退款？`,
      `答：通过苹果账户进行的游戏充值，需要您联系苹果公司进行处理。您可以通过以下两种方式进行申请： <br />
      1）拨打苹果客服电话：400-666-8800。 <br />
      2）苹果官方“针对从 Apple 购买的 App 或内容申请退款”的通道：<a href='https://support.apple.com/zh-cn/HT204084' target='_blank'>https://support.apple.com/zh-cn/HT204084</a>。`
    ]
  ],
  '联系客服': [
    [
      `联系客服电话`,
      `答：您可以拨打未成年专线 400-6501866 联系客服进行处理 (服务时间为每日9:00-18:00)`
    ],
    [
      `通过游戏内客服进行申请【推荐】`,
      `答：【推荐】这是最快速的处理方式。 <br />

      1、首先请您打开游戏：运行孩子充值使用的微信 - 搜索【咸鱼之王】小程序 - 运行游戏 - 在游戏内点击左侧菜单栏【三】按钮（如图1）- 点击【设置】（如图2）- 点击【客服】（如图3），进入客服会话 - 输入“未成年” 并发送。 <br />
      <div class="image-container">
        <div class="image1 render-image-style"></div> 
        <div class="image2 render-image-style"></div> 
        <div class="image3 render-image-style"></div>
      </div>
      2、根据客服窗口弹出的引导信息和链接，请您正确提交未成年人退款申请所需审核资料。提交完成后请您耐心等待，工作人员将会尽快为您进行处理。`
    ],
    [
      `通过公众号方式进行申请 `,
      `答： <br />
      1. 在微信内搜索并关注公众号【疯狂游戏客服平台】- 输入“未成年”并发送。 <br />
      2. 根据客服回复的引导信息和链接，请您正确提交未成年人退款申请所需审核资料。提交完成后请您耐心等待，工作人员将会尽快为您进行处理。
      
      <div class="contact-service-image"></div>`
    ]
  ]
}

export type IKey = '游戏产品防沉迷' | '未成年人消费' | '未成年人退款申请' | '未成年人苹果账号充值' | '联系客服'

interface IUseFq {
  answers: string[][]
  allFq: { [key: string]: string[][] }
  changeAnswer: (key: IKey) => void
}

export default (initial?: IKey): IUseFq => {
  const [q, setQ] = useState<any>([])

  const setFq = (key: IKey) => {
    const value = fq[key];
    setQ(value)
  }

  useEffect(() => {
    if (initial) {
      setFq(initial)
    }
  }, [])

  return {
    answers: q,
    changeAnswer: setFq,
    allFq: fq
  }
}